import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";
import { REGISTRY } from '../../../store/ceeSearchStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import Money from "../../common/moneyComponent";

class CeeSearchCriteria extends React.Component {
    get currency() {
        return this.props.translate(this.props.country === "SK" ? "Common.Currency.EUR" : "Common.Currency.CZK");
    }

    render() {
        return (
            <table className="table table-report-section key-value">
                <colgroup>
                    <col width="30%" />
                    <col width="70%" />
                </colgroup>
                <tbody>
                    {this.renderTableRow(
                        (!isNullOrUndefined(this.props.data.header.fullName)) ?
                            `${this.props.data.header.companyId} (${this.props.data.header.fullName})` :
                            this.props.data.header.companyId, "Search.Common.CompanyId")}
                    {this.renderTableRow(this.props.data.header.pid, "Search.Common.Pid")}
                    {this.renderTableRow(this.props.data.header.companyName, "Report.Common.Title")}
                    {this.props.country === "CZ" && this.renderTableRow(this.props.data.header.surname, "Search.Common.FullName")}
                    {(this.props.country === "SK" && isNullOrUndefined(this.props.data.header.companyId)) && <>
                        {this.renderTableRow(this.props.data.header.name, "Search.Common.FirstName")}
                        {this.renderTableRow(this.props.data.header.surname, "Search.Common.Surname")}
                    </>}
                    {this.renderTableRow(this.props.data.header.birthDateFormated, "Search.Common.BirthDate")}
                    {this.renderTableRow(this.props.data.header.city, "Search.Common.Address")}
                    {this.renderTableRow(this.props.data.header.courtFileNumber, `${this.props.registry === REGISTRY.rpve ? 'RpveDetail.Table.ECLI' : 'Search.Common.CourtFile'}`)}
                    {this.renderTableRow(this.props.data.header.executionFromFormated, "Search.Common.DateRecordingCase")}
                    {this.renderTableRow(this.props.data.header.priceFrom, "Search.Common.MonetaryObligationFrom", "money", { currency: this.currency })}
                    {this.renderObligation(this.props.data.header.obligation)}
                    {(this.props.data.header.maxDetails || this.props.data.header.maxExecutions) && <tr>
                        <td></td>
                        <td>
                            {this.props.translate("Search.Cee.ConditionNote",
                                { maxDet: this.props.data.header.maxDetails || 0, maxExec: this.props.data.header.maxExecutions || 0 })}
                        </td>
                    </tr>}
                </tbody>
            </table>
        )
    }

    renderTableRow(value, label, format = null, translateParams = undefined) {
        if (isNullOrUndefined(value) || typeof value === "string" && value.trim() === "")
            return null;

        return (
            <tr>
                <td><Translate id={label} data={translateParams} /></td>
                <td className="sr-label-value">
                    <div className='gr-flex'>
                        {format === "money" && <Money value={value} />}
                        {format === null && value}
                    </div>
                </td>
            </tr>
        );
    }

    renderObligation (obligation){
        let label = "";
        if (obligation == null)
            return null;

        if (obligation === -1)
            label = "Search.Cee.AllCases";
        if (obligation === 0)
            label = "Search.Cee.Choose";
        if (obligation > 0)
            label = "Search.Cee.First.N.Var";

        return (
            <tr>
                <td><Translate id="Search.Common.MonetaryObligation" /></td>
                <td><Translate id={label} data={{ count: obligation }} /></td>
            </tr>
        );
    }
}

export default withLocalize(CeeSearchCriteria);